import { useQuery } from '@tanstack/react-query'
import apiClient from '../../lib/api-client'

export type HotspotCity = {
  name: string
}

type HotspotResponse = {
  data: Array<{
    id: number
    name: string | null
    address: string
    status: 'online' | 'offline'
    online_pct: number
    rewards_24h: number
    rewards_7d: number
    rewards_30d: number
    city?: HotspotCity
  }>
  meta?: unknown
  error?: unknown
}

export function useTopSpots(range: '24h' | '7d' | '30d' = '24h') {
  return useQuery({
    queryKey: ['top-spots', range],
    queryFn: async () => {
      const result = await apiClient.GET('/api/v2/hotspots/topspots', {
        params: { query: { period: range, per_page: 20 } } as unknown as undefined,
      }) as unknown as HotspotResponse
      if (result.error) throw result.error
      const body = (result as unknown as { data?: { data: HotspotResponse['data'] } }).data
      const list: HotspotResponse['data'] = Array.isArray(body?.data) ? body.data : []

      // F-011: Backend sortiert bei Rewards-Gleichstand (haeufig 0, wenn fuer
      // den Zeitraum noch keine Daten vorliegen) per RANK()-Tie-Break nach
      // Hotspot-ID DESC — dadurch landen zuletzt angelegte (oft eigene) Hotspots
      // ohne echte Rewards unbegruendet auf Platz 1-3. Client-seitig gegen
      // Nullwerte filtern und nach dem gewaehlten Zeitraum neu sortieren, damit
      // die Liste ausschliesslich Hotspots mit echten Rewards zeigt.
      const rewardField = range === '24h' ? 'rewards_24h' : range === '7d' ? 'rewards_7d' : 'rewards_30d'
      return list
        .filter((h) => (h[rewardField] ?? 0) > 0)
        .sort((a, b) => (b[rewardField] ?? 0) - (a[rewardField] ?? 0))
    },
    staleTime: 5 * 60 * 1000,
  })
}
